import watchActiveVisits from "./activeClientsSagas";

export default function* () {
  yield watchActiveVisits();
}
